import { Tooltip } from '@arco-design/web-react';
import styled, { css } from 'styled-components';

import { IconFont } from '@/components';

interface ExtraItem {
  label: string;
  value: string;
  frozenWidth?: number | boolean;
}

export interface VolumeOptionLabelProps {
  iconfontName?: string;
  value: string;
  label?: string;
  extraItems?: ExtraItem[];
  style?: React.CSSProperties;
}

export function VolumeOptionLabel({ iconfontName, value, label, extraItems, style }: VolumeOptionLabelProps) {
  return (
    <OptionLabel style={style}>
      {iconfontName ? (
        <OptionIcon>
          <IconFont name={iconfontName} style={{ fontSize: 36 }} />
        </OptionIcon>
      ) : null}
      <TitleBox>
        <Title>{value}</Title>
        <p>{label}</p>
      </TitleBox>
      {extraItems?.map((item, idx) => (
        <ItemBox key={idx} $frozenWidth={item.frozenWidth}>
          <Tooltip content={item.value} mini>
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.value}</span>
          </Tooltip>
          <p>{item.label}</p>
        </ItemBox>
      ))}
    </OptionLabel>
  );
}

const OptionLabel = styled.div`
  min-height: 52px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const OptionIcon = styled.div`
  display: flex;
  align-items: center;
  opacity: 0.45;
`;

const ItemBaseBox = styled.div`
  line-height: 1rem;
  display: flex;
  flex-direction: column;
  gap: 8px;
  span {
    font-size: 14px;
    word-break: break-all;
    white-space: normal;
  }
  p {
    font-size: 12px;
    opacity: 0.5;
  }
`;

const TitleBox = styled(ItemBaseBox)`
  width: 100%;
`;

const ItemBox = styled(TitleBox)<{ $frozenWidth?: boolean | number }>`
  flex-shrink: 0;
  ${({ $frozenWidth }) => {
    if (typeof $frozenWidth === 'number') {
      return css`
        width: ${$frozenWidth}px;
      `;
    }
    return $frozenWidth
      ? css`
          width: 110px;
        `
      : css`
          min-width: 110px;
        `;
  }};
`;

const Title = styled.span`
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
